<template>
  <div class="table-page invoicing">
    <top-bar :topbarList="invoicingTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { invoicingIndexMixins } from "@/mixins/invoicingIndexMixins";

export default {
  mixins: [invoicingIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.table-page {
  height: 100%;
}
.invoicingHead {
  /* 进销存面包屑导航 */
  box-sizing: border-box;
  width: 100%;
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  z-index: 100;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}

.invoicingHeadDown {
  /* 进销存面包屑导航下方模块 */
  box-sizing: border-box;
  width: 100%;
}

.row {
  display: flex;
}
</style>
<style lang="less">
.invoicingHead {
  /* 进销存面包屑导航 */
  box-sizing: border-box;
  width: 100%;
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  z-index: 100;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}

.invoicingHeadDown {
  /* 进销存面包屑导航下方模块 */
  box-sizing: border-box;
  width: 100%;
  padding: 20px;
}
.invoicing {
  .row {
    display: flex;
  }
  .top-bar + div {
    position: relative;
  }
}
.td td,
.th td {
  vertical-align: middle;
}
</style>
